const fallback = (text: string): Promise<void> => {
  const textArea = document.createElement('textarea');
  textArea.value = text;

  textArea.style.position = 'fixed';
  textArea.style.top = '-9999px';
  textArea.style.left = '-9999px';
  textArea.style.opacity = '0';

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    document.execCommand('copy');
  } catch (err) {
    console.error('Unable to copy to clipboard', err);
  }

  document.body.removeChild(textArea);
  return Promise.resolve();
};

export const copyToClipboard = (text: string): Promise<void> => {
  return window.isSecureContext && navigator.clipboard
    ? navigator.clipboard.writeText(text)
    : fallback(text);
};
